<div [class]="theme">
  <p>Stella BIO APP</p>
  <p>{{ version }}</p>
  <!-- <p>{{ lastUpdate | date: 'yyyy-MM-dd H:mm' }}</p> -->
</div>